exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".collapsible-card{padding:0;margin-bottom:36px!important}.collapsible-card .card-header{margin:0;padding:8px;cursor:pointer;display:flex;justify-content:space-between;border-radius:6px}.collapsible-card .card-header h1,.collapsible-card .card-header span{color:#000;font-weight:600;margin:0;padding:8px;font-size:16px}.collapsible-card .tools{display:flex}.collapsible-card .tools,.collapsible-card .tools span{justify-content:space-between;padding:8px}.collapsible-card.open .card-header{border-bottom:1px solid #f0f0f0;border-radius:6px 6px 0 0;margin:-.55px}.collapsible-card.open .card-content{padding:32px;padding-bottom:calc($padding-lg + $padding-lg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/containers/question/style.scss
// module id = 279
// module chunks = 0